import DateTimePicker from '@react-native-community/datetimepicker';
import T from './T';
import React, {useState} from 'react';
import {useController, useFormContext} from 'react-hook-form';
import {Platform, StyleSheet, Text, TouchableOpacity, View} from 'react-native';
import Icon from '@react-native-vector-icons/fontawesome';

interface DateTimePickerProps {
  name: string;
  label: string;
  rules?: object;
  defaultValue?: Date;
  mode?: 'date' | 'time';
  onValChange?: any;
}

const ControlledDateTimePicker = ({
  name,
  label,
  rules,
  defaultValue,
  mode,
  onValChange,
}: DateTimePickerProps) => {
  const {control} = useFormContext();
  const {
    field: {onChange, value},
    fieldState: {error},
  } = useController({name, control, rules, defaultValue});

  const [isPickerShow, setIsPickerShow] = useState(false);

  const showPicker = () => {
    setIsPickerShow(true);
  };

  const formatDate = (date: Date) => {
    if (!date) return 'No date selected';

    const pad = (number: number) => (number < 10 ? '0' + number : number);

    switch (mode) {
      case 'date':
        return `${pad(date.getDate())}/${pad(
          date.getMonth() + 1,
        )}/${date.getFullYear()}`;
      case 'time':
        return `${pad(date.getHours())}:${pad(date.getMinutes())}`;
      default:
        return 'Invalid mode';
    }
  };

  return (
    <View style={styles.container}>
      {label && <Text style={styles.label}><T>{label}</T></Text>}
      <TouchableOpacity onPress={showPicker} style={styles.iconButton}>
        <Icon name="calendar" size={24} color="black" />
        <Text>{`  ${value ? formatDate(value) : 'Select Date'}`}</Text>
      </TouchableOpacity>
      {isPickerShow && (
        <DateTimePicker
          value={value || new Date()}
          mode={mode ? mode : 'date'}
          display={Platform.OS === 'ios' ? 'spinner' : 'default'}
          onChange={(event, selectedDate) => {
            setIsPickerShow(Platform.OS === 'ios');
            onChange(selectedDate || value || new Date());

            if (onValChange) {
              onValChange(selectedDate || value || new Date());
            }
          }}
          style={[styles.dateTimePicker, error && styles.inputError]}
        />
      )}
      {error && <Text style={styles.error}><T>{error.message}</T></Text>}
    </View>
  );
};

export const BTDateTimePicker = (props: DateTimePickerProps) => {
  const {name} = props;

  const formContext = useFormContext();

  if (!formContext || !name) {
    const msg = !formContext
      ? 'DateTimeInput must be wrapped by the FormProvider'
      : 'Name must be defined';
    console.error(msg);
    return null;
  }

  return <ControlledDateTimePicker {...props} />;
};

const styles = StyleSheet.create({
  label: {
    marginLeft: 0,
  },
  container: {
    flex: -1,
    justifyContent: 'center',
    padding: 0,
  },
  iconButton: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderWidth: 1,
    borderColor: 'grey',
    borderRadius: 4,
  },
  error: {
    marginLeft: 0,
    color: 'red',
  },
  input: {
    backgroundColor: 'white',
    height: 50,
    borderRadius: 4,
    justifyContent: 'center',
  },
  dateTimePicker: {
    backgroundColor: 'white',
    color: 'black',
    width: '100%',
  },
  inputError: {
    borderColor: 'red',
    backgroundColor: '#f9d7d3',
  },
});

